/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { FuelcardControllerService } from './services/fuelcard-controller.service';
import { MySvgControllerService } from './services/my-svg-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    FuelcardControllerService,
    MySvgControllerService,
    ApiConfiguration
  ],
})
export class FuelCardComposerModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<FuelCardComposerModule> {
    return {
      ngModule: FuelCardComposerModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: FuelCardComposerModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('FuelCardComposerModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
